
const  requaredValid =  function(state,name,realTimeName,message){
                let fields = state;
                let msg = "این فیلد را وارد نمایید";
                if((!realTimeName || realTimeName == name)){
                    state.errors[name]=fields[name] ? (state.errors[name] == msg ? '' : state.errors[name]) : message ? message : msg;
                }
                
            
        }


const onlyLettersValid = function(state,name,realTimeName,message){
    let fields = state;
    let msg = "فقط حروف را وارد نمایید";
    if((!realTimeName || realTimeName == name) && fields[name]){
               state.errors[name]=(typeof fields[name] !== "undefined" && !fields[name].match(/^[a-zA-Z]+$/))
               ? (message ? message : msg) 
               : (state.errors[name] == msg ? '' : state.errors[name])
            }

}

const emailValid = function(state,name,realTimeName,message){
    let fields = state;
    let msg = "ایمیل صحیح نمی باشد";
    if((!realTimeName || realTimeName == name) && fields[name]){
    if(typeof fields[name] !== "undefined"){
       let lastAtPos = fields[name].lastIndexOf('@');
       let lastDotPos = fields[name].lastIndexOf('.');
 
       if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields[name].indexOf('@@') == -1 && lastDotPos > 2 && (fields[name].length - lastDotPos) > 2)) {
        state.errors[name]= message ? message : msg;
        }
        else{
            state.errors[name]= state.errors[name] == msg ? '' : state.errors[name];

        }
      }  
    }
}   

const finalizeValid = function(errors){ 
        for (var key in errors) {
            if (errors[key] !== null && errors[key] != "" && errors[key] !=undefined)
                return false;
        }
        return true;  
}

export {requaredValid,
        onlyLettersValid,
        emailValid,
        finalizeValid};


